import React, { Fragment } from 'react';
import { asAppConfigSection } from 'Src/types/server-helpers';
import appConfig from 'Config';
import { useAppContext } from 'Context/ReactAppContext';
export const Sentry = () => {
  const { locale } = useAppContext();
  const appVersion = appConfig.get('APP_VERSION');
  const deploymentEnv = appConfig.get('DEPLOYMENT_ENV');
  const { enabled, url, dsn } = asAppConfigSection<{
    enabled: boolean;
    url: string;
    dsn: string;
  }>(appConfig.get('clientError.sentry'));

  if (enabled && url && dsn) {
    return (
      <Fragment>
        <script key="sentry-lib" async defer src={url} crossOrigin="anonymous" />
        <script
          dangerouslySetInnerHTML={{
            __html: `
if (window.Sentry) {
  Sentry.init({
    dsn: '${dsn}',
    environment: '${deploymentEnv}',
    release: '${appVersion}',
  });
  Sentry.configureScope(function (scope) {
    scope.setExtra('locale', '${locale}');
    scope.setTag('locale', '${locale}');
  });
}
          `,
          }}
        />
      </Fragment>
    );
  }

  return null;
};
